import React, {useEffect, useCallback} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {LoginContentColumn} from 'components/customer/Auth/helper/layout';
import styled from 'styled-components';
import {CBCButton} from 'components/customer/Auth/StyledElements';
import {LocationHelper} from 'shared/LocationHelper';

const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    & > p > a {
        white-space: nowrap;
    }
    & > h4 {
        margin-bottom: 15px;
    }
    ${({theme}) =>
        theme.device.isSmall &&
        `
        & > h1 { font-size: 2rem; }
        & > h4 { font-size: 1rem; }
        & > p { font-size: 0.9rem; }
    `}
`;

export const SetPasswordSuccess = () => {
    const redirectToDashboard = useCallback(() => {
        LocationHelper.redirectTo('/v2');
    }, [LocationHelper]);

    useEffect(() => {
        const timer = setTimeout(() => {
            redirectToDashboard();
        }, 5000);

        return () => clearTimeout(timer);
    }, [redirectToDashboard]);

    return (
        <Container>
            <Row>
                <LoginContentColumn>
                    <StyledContent>
                        <h4 data-cy="success-header">
                            Your password was set successfully!
                        </h4>
                        <p data-cy="success-message">
                            {`You'll be automatically logged into your account in a few seconds.`}
                        </p>
                        <Col style={{marginBottom: '10px'}}>
                            <CBCButton
                                type="submit"
                                onClick={redirectToDashboard}
                                $width="160px">
                                Log me in now
                            </CBCButton>
                        </Col>
                    </StyledContent>
                </LoginContentColumn>
            </Row>
        </Container>
    );
};
